import { Cart, Mutation } from 'service/types';
import { removeCartItemsMutation } from 'service/mutations/cart';
import { apiMutate } from 'service/utils/mutation';
import ServiceConfigs from 'service/config';
import { RenderingRegistry } from 'common/lib/registries';

type useRemoveCartItemsType = () => (variables: { cartId: string; cartItemIds: string[] }) => Promise<Partial<Cart>>;

const useRemoveCartItems: useRemoveCartItemsType =
  () =>
  ({ cartId, cartItemIds }) => {
    const isManualOrder = RenderingRegistry.getIsManualOrder();

    return apiMutate({
      mutation: cartId ? removeCartItemsMutation : null,
      variables: { cartId, cartItemIds, isManualOrder },
      requestHeaders: { ...ServiceConfigs.getAuthorizationHeader() },
      handler: (res: Mutation) => res?.deleteItemFromCart?.cart,
    });
  };

export default useRemoveCartItems;
